<template>
    <div
      v-if="allow_dl_or_ssn"
      class="row"
    >
      <!-- Driver license number  -->
      <div class="col-md-4 col-md-offset-1">
        <div class="form-group">
          <label class="control-label">
            {{computeCaption(fields_en['driver_license_number'], $store.state.lang.value.toLowerCase())}}
          </label>
          <input
            class="form-control"
            type="text"
            data-vv-as="Driver License Number"
            name="driver_license_number"
            v-model="model.driver_license_number"
          />
          <div class="default-grey font-small" v-show="getFieldDescription('driver_license_number')" v-html="getFieldDescription('driver_license_number') || ''"></div>
        </div>
      </div>

      <div class="col-md-1 mb-10">
        <small class="border-none">OR</small>
      </div>

      <div class="col-md-5">
        <div class="form-group">
          <label
            class="control-label"
            :class="{ required: required_dl_or_ssn || $store.state.required_uninsured_ssn}"
          >
            {{computeCaption(fields_en['social_security_number'], $store.state.lang.value.toLowerCase())}}
          </label>
          <input
            class="form-control ssn-cleave-format1"
            autocomplete="off"
            type="text"
            data-vv-as="Social Security Number"
            name="social_security_number"
            v-validate="modelValidations.social_security_number"
            v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
            v-model="model.social_security_number"
          />
          <div class="default-grey font-small" v-show="getFieldDescription('social_number')" v-html="getFieldDescription('social_number') || ''"></div>
          <small class="text-danger" v-show="social_security_number.invalid">
            {{computeCaption(getError("social_security_number"), $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>

      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <input
            class="form-control display-none"
            type="text"
            data-vv-as="Social Number"
            name="error_uninsured"
            v-model="model.error_uninsured"
            placeholder="ex: John Smith"
          />
          <small class="text-danger" v-show="model.error_uninsured">
            {{computeCaption(this.model.error_uninsured, $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>
</template>

<script>
import {RadioButton, RadioGroup} from 'element-ui'
import {TranslationsUtils} from '../../../../../../utils/Translations'
import {AccessionUtils} from '../../../../../../utils/AccessionDetailsProcessing'
import {mapFields} from 'vee-validate'
import Cleave from 'cleave.js'
import {FormatterUtils} from '../../../../../../utils/Formatter'
require('cleave.js/dist/addons/cleave-phone.us')

export default {
  components: {
    [RadioButton.name]: RadioButton,
    [RadioGroup.name]: RadioGroup
  },
  props: ['insurancePay', 'allowPayment', 'selectedBill'],
  mixins: [TranslationsUtils, AccessionUtils, FormatterUtils],
  data () {
    return {
      fields_en: {
        driver_license_number: 'Driver License Number',
        social_security_number: 'Social Security Number'
      },
      model: {
        primary_insurance: '',
        primary_insurance_name_input: '',
        policy_number: '',
        group_number: '',
        relationship: '',
        insured_first_name: '',
        insured_last_name: '',
        insured_date_of_birth: '',
        insured_date_of_birth_pretty: '',
        insured_address_components: '',
        insured_gender: '',
        insurance_card_images: [],
        insurance_card_names: [],
        error_uninsured: '',
        note: '',
        social_security_number: '',
        driver_license_number: ''
      },
      modelValidations: {
        social_security_number: {
          min: 11,
          max: 11
        }
      },
      validationObject: {
        uninsured_ssn: false,
        uninsured_driver_license: false
      }
    }
  },
  beforeMount () {
    this.$emit('validateBill', false)
    this.populateModel('uninsured')
    this.model.social_security_number = this.$store.state.personIdentifierSection.med_social_security_number
    this.model.driver_license_number = this.$store.state.personIdentifierSection.med_driver_license_number
    // if the fields are not present or not required they will be validated
    if (this.allow_dl_or_ssn && !this.required_dl_or_ssn || !this.allow_dl_or_ssn) {
      this.validationObject.uninsured_ssn = true
      this.validationObject.uninsured_driver_license = true
    }
    if (this.$store.state.required_uninsured_ssn) {
      this.validationObject.uninsured_ssn = false
    }
  },
  methods: {
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    async validate () {
      if (this.required_dl_or_ssn) {
        if (!this.model.driver_license_number && !this.model.social_security_number) {
          this.model.error_uninsured = 'Please complete your Driver License Number or your Social Number'
          document.getElementsByName('driver_license_number')[0].focus()
          return false
        }
      }
      if (this.$store.state.required_uninsured_ssn && !this.model.social_security_number) {
        this.$validator.errors.add({field: 'social_security_number', msg: 'Social Security Number field is required'})
        let field = this.$validator._resolveField('social_security_number')
        field.setFlags({invalid: true})
        return false
      }
      return true
    },
    resetAddressObject () {
      let resetAddress = {
        name: '',
        original_name: '',
        delivery_line_1: '',
        city_name: '',
        county: '',
        state_abbreviation: '',
        zipcode: '',
        plus4_code: '',
        county_fips: '',
        country: ''
      }
      return resetAddress
    },
    populateModel (type) {
      this.model.primary_insurance = type
      this.model.policy_number = type
      this.model.group_number = type
      this.model.insurance_card_image = ''
      this.model.social_security_number = ''
      this.model.relationship = 'Self'
      this.model.insured_first_name = this.$store.state.insuranceData.first_name
      this.model.insured_last_name = this.$store.state.insuranceData.last_name
      this.model.insured_date_of_birth = this.$store.state.insuranceData.dob
      this.model.insured_date_of_birth_pretty = this.$store.state.insuranceData.dob_pretty
      this.model.insured_gender = this.$store.state.insuranceData.gender
      this.model.insured_address_components = this.$store.state.insuranceData.addressComponents || this.resetAddressObject()
      this.model.insured_address2 = this.$store.state.insuranceData.address2
    }
  },
  computed: {
    allow_dl_or_ssn () {
      return this.$store.state.allow_dl_or_ssn
    },
    required_dl_or_ssn () {
      return this.$store.state.dl_or_ssn_required_by_client
    },
    ...mapFields(['social_security_number'])
  },
  watch: {
    '$store.state.personIdentifierSection': {
      handler: function (before, after) {
        this.model.social_security_number = this.$store.state.personIdentifierSection.med_social_security_number
        this.model.driver_license_number = this.$store.state.personIdentifierSection.med_driver_license_number
      },
      deep: true
    },
    'model': {
      handler: function (value) {
        this.$emit('updateModel', this.model)
      },
      deep: true
    },
    'validationObject': {
      handler: function (value) {
        if (Object.values(value).every(field => field === true)) {
          this.$emit('validateBill', true)
        } else {
          this.$emit('validateBill', false)
        }
      },
      deep: true
    },
    'model.social_security_number': {
      handler: function (after, before) {
        this.model.error_uninsured = ''
        if (after.length < this.modelValidations.social_security_number.min) {
          let ssnCleave = new Cleave('.ssn-cleave-format1', {
            delimiters: ['-', '-'],
            numericOnly: true,
            uppercase: true,
            blocks: [3, 2, 4]
          })
          this.model.social_security_number = ssnCleave.getFormattedValue()
        } else if (after.length > this.modelValidations.social_security_number.max) {
          this.model.social_security_number = this.model.social_security_number.substr(0, this.model.social_security_number.length - 1)
        }
        if (this.model.social_security_number.length === this.modelValidations.social_security_number.max) {
          this.validationObject.uninsured_driver_license = true
          this.validationObject.uninsured_ssn = true
        } else {
          if (this.required_dl_or_ssn && this.model.driver_license_number === '' && this.model.social_security_number.length < this.modelValidations.social_security_number.max) {
            this.validationObject.uninsured_ssn = false
            this.validationObject.uninsured_driver_license = false
          }
        }
        if (this.$store.state.required_uninsured_ssn && (this.model.social_security_number === '' || this.model.social_security_number.length < 11)) {
          this.validationObject.uninsured_ssn = false
          this.model.error_uninsured = 'Please complete your Social Number'
        } else {
          this.validationObject.uninsured_ssn = true
        }
      },
      deep: true
    },
    'model.driver_license_number': {
      handler: function (before, after) {
        this.model.error_uninsured = ''
        if (this.model.driver_license_number || this.model.social_security_number) {
          this.validationObject.uninsured_driver_license = true
          this.validationObject.uninsured_ssn = true
        } else {
          if (this.required_dl_or_ssn && this.model.driver_license_number === '' && this.model.social_security_number.length < this.modelValidations.social_security_number.max) {
            this.validationObject.uninsured_ssn = false
            this.validationObject.uninsured_driver_license = false
          }
        }
        if (this.$store.state.required_uninsured_ssn && this.model.social_security_number === '') {
          this.validationObject.uninsured_ssn = false
          this.model.error_uninsured = 'Please complete your Social Number'
        } else {
          this.validationObject.uninsured_ssn = true
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../assets/sass/paper/variables";
.display-none{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/BillParts/Uninsured.vue